import * as yup from 'yup'
import 'yup-phone'

export default yup.object().shape({
  permissionTypeName: yup.string().required().label('Permission Type'),
  delegateId: yup.object().required().label('Delegate user'),
  userId: yup.object().required().label('User providing access'),
})
